import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UxIconEnum, UxPriorityEnum, UxSizeEnum, UxAction, UxPositionEnum, UxThemesEnum, UxPreloader, UxPreloaderTypeEnum } from "@imaginelearning/mps-ux-component-library";
import { ButtonTypeEnum } from "./button.props";
function Button(props) {
    var t = useTranslation().t;
    var _a = useState(props.enabled), enabled = _a[0], setEnabled = _a[1];
    var _b = useState(false), loader = _b[0], setLoader = _b[1];
    var isk2 = props.theme === UxThemesEnum.STUDENT_K_2;
    var title = t("Continue");
    var priority = UxPriorityEnum.PRIMARY;
    var icon = UxIconEnum.ARROW_RIGHT;
    var textPosition = UxPositionEnum.LEFT;
    switch (props.type) {
        case ButtonTypeEnum.CHECK_ANSWER:
            title = t("Check Answer");
            priority = UxPriorityEnum.SUCCESS;
            icon = UxIconEnum.CHECK_SQUARE;
            textPosition = UxPositionEnum.RIGHT;
            break;
        case ButtonTypeEnum.SUBMIT:
            title = t(isk2 ? "Next" : "Submit");
            break;
        case ButtonTypeEnum.CONTINUE:
            title = t(isk2 ? "Go" : "Continue");
            break;
        case ButtonTypeEnum.TRY_AGAIN:
            title = t("Try Again");
            break;
    }
    if (props.hideLoader && loader) {
        setLoader(false);
    }
    var handleClick = function () {
        setEnabled(false);
        props.resetLoader ? props.resetLoader() : "";
        if (props.type !== ButtonTypeEnum.TRY_AGAIN)
            setLoader(true);
        if (props.callback && typeof props.callback === "function") {
            props.callback();
        }
    };
    useEffect(function () {
        setEnabled(props.enabled);
    }, [props, setEnabled]);
    return (React.createElement(React.Fragment, null,
        loader && (React.createElement(UxPreloader, { type: UxPreloaderTypeEnum.THREE_DOTS, fill: UxPriorityEnum.PRIMARY, className: "d-flex mx-auto" })),
        !loader && (React.createElement(UxAction, { enabled: enabled, callback: handleClick, text: title, priority: priority, className: "ft-btns ".concat(props.type) !== ButtonTypeEnum.TRY_AGAIN ? "footer-action-btn" : "", icon: props.type !== ButtonTypeEnum.SUBMIT
                ? {
                    icon: icon,
                    size: UxSizeEnum.LARGE,
                    title: title,
                    textPosition: textPosition
                }
                : undefined }))));
}
export default Button;
